<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/wuhou/4/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            为全面落实人才强国战略、创新驱动发展战略，深入实施人才强区战略，统筹推进战略科学家和科技领军人才引进等工程，充分发挥科技人才的创造力和积极性，全方位培养和使用好科技人才，结合武侯区实际，制定本细则。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/4/title1.png" alt="" />
          <div class="content">
            <div class="commonCircle">
              <div
                class="commonCircle-circle"
                style="margin-right: 0.1rem"
              ></div>
              <div class="commonCircle-font">实施柔性引才</div>
            </div>
            <div class="des" style="margin-top: 0.1rem">
              <div style="margin-bottom: 0.2rem">
                每柔性引进1名战略科学家，按劳务报酬的50%一次性给予用人单位最高50万元引才补贴；每柔性引进1名科技领军人才，按劳务报酬的20%一次性给予用人单位最高50万元引才补贴。
              </div>
              <div>
                （1）2023年1月1日（含）以后，工商注册、税收关系和统计关系均在武侯区行政区域内的重点企业、招才引智高能级项目。
              </div>
              <div>
                （2）战略科学家是指《成都市人才分类目录》中A类人才、B类人才（科技创新类）；科技领军人才是指C类人才（科技创新类）及以上人才。
              </div>
            </div>
            <div class="commonCircle">
              <div
                class="commonCircle-circle"
                style="margin-right: 0.1rem"
              ></div>
              <div class="commonCircle-font">
                实施青年人才成长工程：青年大学生创业项目奖励
              </div>
            </div>
            <div class="des" style="margin-top: 0.1rem">
              <div style="margin-bottom: 0.2rem">
                对在国家部委主办的创新创业大赛中获得第一等次奖、第二等次奖、第三等次奖和优秀奖等，并在武侯区落地转化的项目，可分别给予60万元、40万元、20万元、10万元的奖励，申请人应为获奖者或获奖团队排名前三的核心成员或技术发明人的核心成员。
              </div>
              <div>
                （1）对在武侯区新登记注册具有独立法人资格的企业，申请人持股比例不低于30%，实施获奖项目的转化，且企业实际运营满3个月；对在武侯区已成立注册企业的项目，企业注册成立时间截止申报当年1月1日不超过3年，申请人持股比例不低于30%，每个企业允许1名符合条件的人员申报。
              </div>
              <div>
                （2）创办的企业依法经营，无不良记录，无相关知识产权纠纷；
              </div>
              <div>（3）获奖项目未在其他地方注册从事类似转化工作的公司。</div>
            </div>
            <div class="commonCircle">
              <div
                class="commonCircle-circle"
                style="margin-right: 0.1rem"
              ></div>
              <div class="commonCircle-font">建设企业科技创新平台</div>
            </div>
            <div class="des" style="margin-top: 0.1rem">
              <div style="margin-bottom: 0.2rem">
                对提供重大科研基础设施和大型科研仪器开放共享服务的申报主体，按接收科技创新券的20%给予每年最高30万元区级配套奖励；开放共享服务奖励可用于对服务团队、个人的奖励。
              </div>
              <div>
                （1）根据《成都市科技创新券管理办法》，科技创新券是支持科技型中小企业、高新技术企业、高等学校、科研院所、技术转移机构、新型研发机构、医疗卫生机构开展创新研发、成果转移转化、人才培养等相关活动购买科技服务，支持服务机构开放共享创新资源、提供相关科技服务的一种政策工具。科技创新券采用电子券形式。
              </div>
              <div>
                （2）2023年1月1日（含）以后，在武侯区行政区域内具有独立法人资格的科技型中小企业、高新技术企业、高等学校、科研院所、技术转移机构、新型研发机构、医疗卫生机构通过科技创新券提供开放共享平台或服务。
              </div>
            </div>
            <div class="commonCircle">
              <div
                class="commonCircle-circle"
                style="margin-right: 0.1rem"
              ></div>
              <div class="commonCircle-font">建设科技成果转移转化平台</div>
            </div>
            <div class="des" style="margin-top: 0.1rem">
              <div>
                2023年1月1日（含）以后，通过技术转让、技术许可、技术开发方式向武侯区企业提供技术成果的在武侯区行政区域内具有独立法人资格的企事业单位。按照在武侯转化的技术合同实际成交额的1%给予单个项目最高20万后补助，每个申报主体单一年度资助总额最高100万元奖励。资助经费可作为科技成果转化收益奖励给成果项目团队及个人。
              </div>
            </div>
          </div>
        </div>
        <div class="part-four">
          <img
            src="../../assets/imgs/wuhou/4/title2.png"
            class="part-two-title-img"
          />
          <div class="main-content">
            <div class="part-four-items">
              <div class="title-bg">初审</div>
              <div class="part-four-content1">
                符合条件的申报主体，向税收关系所属街道提出申请，并附相关证明材料，经街道提出初审意见后，交区新经济局审核。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">
                <div class="extendFont">审核</div>
              </div>
              <div class="part-four-content1">
                区新经济局受理资助申报后，报请区新经济局党组会议审议。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg3">资金拨付</div>
              <div class="part-four-content1">
                资助经费按财政专项资金规定的渠道下达到相关街道后组织拨付。
              </div>
            </div>
            <div class="part-four-items" style="border: none">
              <div class="title-bg title-bg4">申报周期</div>
              <div class="part-four-content1">每年一次。</div>
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="../../assets/imgs/wuhou/4/title3.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-85082792">028-85082792</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              武侯区经科信局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="info" src="../../assets/imgs/147/code.png" />
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.commonCircle {
  display: flex;
  align-items: center;
  margin: 0.19rem 0;
  &-circle {
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    border: 0.06rem solid #ff6d60;
    flex-shrink: 0;
  }
  &-font {
    font-size: 0.34rem;
    color: #333;
    font-weight: 600;
  }
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    // height: 4.73rem;
  }

  .technological-process {
    transform: translateY(-2rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
